import { render, staticRenderFns } from "./DatosExtras.vue?vue&type=template&id=40c5f4a6&"
import script from "./DatosExtras.vue?vue&type=script&lang=js&"
export * from "./DatosExtras.vue?vue&type=script&lang=js&"
import style0 from "./DatosExtras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports